<template>
  <div class="developing-page">
    <div class="developing-card">
      <p class="title">正在开发中……</p>
      <!-- <p v-if="pageTitle" class="subtitle">{{ pageTitle }}</p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "DevelopingPage",
  computed: {
    pageTitle() {
      return this.$route.meta.title || "";
    },
  },
};
</script>

<style scoped lang="scss">
.developing-page {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 180px 30px 40px;
}

.developing-card {
  width: 100%;
  text-align: center;
}

.title {
  margin: 0;
  font-size: 30px;
  color: #999;
}

.subtitle {
  margin: 16px 0 0;
  font-size: 26px;
  color: rgba(255, 255, 255, 0.65);
}
</style>
